import { render, staticRenderFns } from "./PdvView.vue?vue&type=template&id=523bc010&scoped=true"
import script from "./PdvView.vue?vue&type=script&lang=ts"
export * from "./PdvView.vue?vue&type=script&lang=ts"
import style0 from "./PdvView.vue?vue&type=style&index=0&id=523bc010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523bc010",
  null
  
)

export default component.exports